import {IProfile} from "StateInterface";
import {FIELD_NAMES} from "profile/enums";
import {IWorkDetailsFields} from "IncompleteInfoV2/WorkDetails/index";
import {dateToInputString} from "IncompleteInfoV2/utils";
import {validations} from "IncompleteInfoV2/validations";
import {monthsToDate} from "loan-application/utils";

export const companyTypeOptions = [
    {
        name: "Select one",
        value: "",
    },
    {
        name: "PRIVATE LIMITED",
        value: "PRIVATE_LIMITED",
    },
    {
        name: "PARTNERSHIP",
        value: "PARTNERSHIP",
    },
    {
        name: "LLP",
        value: "LLP",
    },
    {
        name: "PROPRIETORSHIP",
        value: "PROPRIETORSHIP",
    },
    {
        name: "GOVERNMENT",
        value: "GOVERNMENT",
    },
    {
        name: "OTHERS",
        value: "OTHERS",
    },
];

export const getInitialValues = (profile: IProfile): IWorkDetailsFields => {
    return {
        currentEmployer: profile.currentEmployer,
        employerType: profile.employerType,
        workCin: profile.workCin,
        employeeId: profile.employeeId,
        designation: profile.designation,
        workExperienceMonths: profile.workExperienceMonths,
        house: profile.workAddress && profile.workAddress.house,
        locality: profile.workAddress && profile.workAddress.locality,
        pincode: profile.workAddress && profile.workAddress.pincode,
        duration: profile.duration && dateToInputString(profile.duration),
        landmark: profile.workAddress && profile.workAddress.landmark,
        street: profile.workAddress && profile.workAddress.street,
    };
};

export  const profileUpdate = (workFields: IWorkDetailsFields) => {
    const profile = {
        workAddress: {},
    };
    const workAddressFields: string[] =
    [
        FIELD_NAMES.HOUSE,
        FIELD_NAMES.LOCALITY,
        FIELD_NAMES.PINCODE,
        FIELD_NAMES.LANDMARK,
        FIELD_NAMES.STREET,
    ];
    Object.keys(workFields).forEach((key) => {
        if (workAddressFields.includes(key)) {
            profile["workAddress"][key] = workFields[key];
        } else {
            profile[key] = workFields[key];
        }
    });
    return profile;
};

export const workDetailsValidation = (workDetails: IWorkDetailsFields) => {
    const durationMinMax = {
        [FIELD_NAMES.DURATION]: {max: 60},
    };
    const error = {...validations(workDetails, durationMinMax)};
    if (monthsToDate(workDetails.workExperienceMonths) > new Date(workDetails.duration).getTime()) {
        error[FIELD_NAMES.DURATION] = "Current experience cannot be more than total experience";
    } else if (!workDetails.workCin) {
        error[FIELD_NAMES.WORK_CIN] = "Please provide full or correct name of the company.";
    }
    return error;
};
